<template>
  <div>
    <v-card class="card--shadow">
      <v-card-title class="purple accent-4">
        <div class="subtitle-1 white--text">Patient Form</div>
      </v-card-title>
      <v-card-text>
        <form-require-noti />
        <v-row>
          <v-col lg="4">
            <label>Name <require-sign /> </label>
            <v-text-field
              v-model.trim="patient.name"
              :error-messages="handleFieldErrors($v.patient.name)"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col md="2">
            <label>Day <require-sign /></label>
            <v-select
              :items="days"
              v-model="computeDay"
              item-text="text"
              item-value="value"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col md="2">
            <label>Month <require-sign /></label>
            <v-select
              :items="months"
              v-model="computeMonth"
              item-text="text"
              item-value="value"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col md="2">
            <label>Year <require-sign /></label>
            <v-select
              :items="years"
              v-model="computeYear"
              item-text="text"
              item-value="value"
              @change="handelCalculateAge"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col lg="2">
            <label>Age </label>
            <v-text-field
              @keyup="calcuateDOBfromAge"
              :disabled="patient.dob ? true : false"
              v-model="computeAge"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col lg="4">
            <label>Sex <require-sign /></label>
            <v-radio-group
              :error-messages="handleFieldErrors($v.patient.sex)"
              v-model="patient.sex"
              row
            >
              <v-radio label="Male" value="1"></v-radio>
              <v-radio label="Female" value="2"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col md="3">
            <label>Weight (kg)</label>
            <v-text-field
              v-model.number="patient.weight"
              @input="calculateBMI"
              type="number"
              outlined
              dense
              suffix="kg"
            ></v-text-field>
          </v-col>
          <v-col md="3">
            <label>Height (cm)</label>
            <v-text-field
              v-model.number="patient.height"
              @input="calculateBMI"
              type="number"
              outlined
              dense
              suffix="cm"
            ></v-text-field>
          </v-col>
          <v-col md="2">
            <label>BMI</label>
            <v-text-field
              :value="computedBMI"
              type="text"
              outlined
              dense
              readonly
              disabled
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col md="3">
            <label>Xpert (MTB/RIF)</label>
            <v-text-field
              v-model.trim="patient.gene_code"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col md="3">
            <label>Xpert (MTB/RIF) Result</label>
            <v-select
              :items="geneResultOpt"
              v-model="patient.gene_result"
              item-text="text"
              item-value="value"
              dense
              outlined
            ></v-select>
          </v-col>
          <v-col lg="3">
            <label>Xpert (MTB/RIF) Date</label>
            <date-picker
              @clearDate="patient.gene_date = null"
              :date="patient.gene_date"
              v-model="patient.gene_date"
            />
          </v-col>
          <v-col lg="3">
            <label>Xpert Result Received Date</label>
            <date-picker
              @clearDate="patient.gene_result_receive_date = null"
              :date="patient.gene_result_receive_date"
              v-model="patient.gene_result_receive_date"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col md="3">
            <label>Lab Test Name</label>
            <v-text-field
              v-model.trim="patient.lab_test_name"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col md="3">
            <label>Lab Code</label>
            <v-text-field
              v-model.trim="patient.lab_code"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col lg="3">
            <label>Lab Date</label>
            <date-picker
              @clearDate="patient.lab_date = null"
              :date="patient.lab_date"
              v-model="patient.lab_date"
            />
          </v-col>
          <v-col md="3">
            <label>Lab Result</label>
            <v-text-field
              v-model.trim="patient.lab_result"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="card--shadow">
      <v-card-text>
        <v-row>
          <v-col md="6">
            <label>Address <require-sign /></label>
            <v-text-field
              v-model.trim="patient.address"
              :error-messages="handleFieldErrors($v.patient.address)"
              type="text"
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col lg="4">
            <label>Pre Enroll <require-sign /></label>
            <v-radio-group
              :error-messages="handleFieldErrors($v.patient.pre_enroll)"
              v-model="patient.pre_enroll"
              row
            >
              <v-radio label="Yes" value="1"></v-radio>
              <v-radio label="No" value="0"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="patient.id">
          <v-col lg="12">
            <label>Remark</label>
            <v-textarea
              rows="3"
              placeholder="remark..."
              v-model.trim="patient.remark"
              outlined
              dense
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          v-if="patient.id"
          @click.prevent="emitData"
          class="form-btn"
        >
          <v-icon left>mdi-chevron-right-circle-outline</v-icon>Update
        </v-btn>
        <v-btn
          :loading="loading"
          v-else
          @click.prevent="emitData"
          class="form-btn"
        >
          <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";
import FormRequireNoti from "@/components/notification/FormRequireNoti";
import RequireSign from "@/components/notification/RequireSign";
import DatePicker from "@/components/common/DatePicker.vue";

export default {
  components: { FormRequireNoti, RequireSign, DatePicker },

  mixins: [ValidationMixin],
  props: {
    patient: {
      type: Object,
      default: () => {
        return {
          name: null,
          address: null,
          dob: null,

          sex: null,
          weight: null,
          height: null,
          bmi: null,
          gene_code: null,
          gene_result: null,
          gene_date: null,
          gene_result_receive_date:null,
          lab_test_name: null,
          lab_code: null,
          lab_date: null,
          lab_result: null,
          pre_enroll: null,
          remark: null,
        };
      },
    },
  },
  data: () => ({
    day: null,
    month: null,
    year: null,
    age: null,
    labResultOpt: [
      { value: 1, text: "A" },
      { value: 2, text: "B" },
    ],
    geneResultOpt: [
      { value: 1, text: "MTB not detected" },
      { value: 2, text: "MTB detected" },
      { value: 3, text: "Rifampicin resistant" },
      { value: 4, text: "MTB (+)Rif resistance indeterminate" },
      { value: 5, text: "Invalid" },
    ],
  }),
  validations: {
    patient: {
      name: { required },
      address: { required },
      sex: { required },
      pre_enroll: { required },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    days() {
      return this.generteDateFormatOption(31);
    },
    months() {
      return this.generteDateFormatOption(12);
    },
    years() {
      return this.generteDateFormatOption(1940);
    },
    computeDay: {
      get() {
        if(this.day) return this.day;
        if (this.patient.dob) return Number(this.patient.dob.split("-")[2]);
        return null;
      },
      set(val) {
        this.day = val;
      },
    },
    computeMonth: {
      get() {
        if(this.month) return this.month;
        if (this.patient.dob) return Number(this.patient.dob.split("-")[1]);
        return null;
      },
      set(val) {
        this.month = val;
      },
    },
    computeYear: {
      get() {
        if(this.year) return this.year;
        if (this.patient.dob) return Number(this.patient.dob.split("-")[0]);
        return null;
      },
      set(val) {
        this.year = val;
      },
    },
    computeAge: {
      get() {
        if (this.age) {
          return this.age;
        }
        if(this.patient.dob)
        return this.calculateAge(this.patient.dob);
        return null
      },
      set(val) {
        this.age = val;
      },
    },
    computedBMI() {
      if (this.patient.weight && this.patient.height) {
        const heightInMeters = this.patient.height / 100;
        const bmi = this.patient.weight / (heightInMeters * heightInMeters);
        return bmi.toFixed(2);
      }
      return '';
    },
  },
  methods: {
    calcuateDOBfromAge() {
      const today = new Date();
      const currentYear = today.getFullYear();
      this.year = currentYear - this.age;
      this.month = 1;
      this.day = 1;
    },
    handelCalculateAge() {
      let currentDate = new Date();
      let dob = String(this.year).concat(
        "-",
        String(this.month).concat("-", this.day)
      );
      let birthDate = new Date(dob);
      let age = currentDate.getFullYear() - birthDate.getFullYear();
      let month = currentDate.getMonth() - birthDate.getMonth();
      if (
        month < 0 ||
        (month === 0 && currentDate.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      this.computeAge = age;
    },
    calculateAge(dob) {
      let currentDate = new Date();
      let birthDate = new Date(dob);
      let age = currentDate.getFullYear() - birthDate.getFullYear();
      let month = currentDate.getMonth() - birthDate.getMonth();
      if (
        month < 0 ||
        (month === 0 && currentDate.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    },
    generteDateFormatOption(value) {
      const isFourDigit = /^[0-9]{4}$/.test(value);
      let values = [];
      let startPoint = isFourDigit ? 1920 : 0;
      let endPoint = isFourDigit ? new Date().getFullYear() : value;
      while (startPoint < endPoint) {
        startPoint = startPoint + 1;
        values.push({ text: startPoint, value: startPoint });
      }
      return values;
    },
    calculateBMI() {
      if (this.patient.weight && this.patient.height) {
        const heightInMeters = this.patient.height / 100;
        const bmi = this.patient.weight / (heightInMeters * heightInMeters);
        this.patient.bmi = parseFloat(bmi.toFixed(2));
      } else {
        this.patient.bmi = null;
      }
    },
    emitData() {
      this.$v.$touch();
      let dob = String(this.year).concat(
        "-",
        String(this.month).concat("-", this.day)
      );
      if(this.year == null && this.month == null && this.day == null){
        dob = this.patient.dob
      }
      if (!this.$v.$invalid) {
        let data = {
          name: this.patient.name,
          sex: this.patient.sex,
          dob: dob,
          address: this.patient.address,
          weight: this.patient.weight,
          height: this.patient.height,
          bmi: this.patient.bmi,
          gene_result: this.patient.gene_result,
          gene_date: this.patient.gene_date,
          gene_result_receive_date:this.patient.gene_result_receive_date,
          gene_code: this.patient.gene_code,
          lab_test_name: this.patient.lab_test_name,
          lab_code: this.patient.lab_code,
          lab_result: this.patient.lab_result,
          lab_date: this.patient.lab_date,
          pre_enroll: this.patient.pre_enroll,
          township_id: this.$route.params.township_id
        };


        this.patient.id ? (data.id = this.patient.id) : false;
        this.patient.remark
          ? (data.remark = this.patient.remark)
          : (data.remark = "");
        this.$emit("emitData", data);

        this.$v.$reset();
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  margin: 20px 0px !important;
}
</style>
